var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:_vm.linkClass,attrs:{"href":_vm.linkUrl,"title":_vm.linkTitle},domProps:{"textContent":_vm._s(_vm.linkText)},on:{"click":_vm.ctaClick}})}
var staticRenderFns = []

export { render, staticRenderFns }